// frontend/src/pages/Edicao.jsx

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const API_BASE_URL = 'https://sigoapi.jhe-etes.com.br/api';

function Edicao() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  
  // Estado do Formulário
  const [formData, setFormData] = useState({
    nome: '',
    descricao_curta: '',
    descricao_completa: '',
    status_atual: '',
    vazao_atual_ls: '',
    vazao_futura_ls: '',
    populacao_atendida: ''
  });

  // 1. Carregar dados atuais ao abrir a tela
  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch(`${API_BASE_URL}/empreendimentos/${id}`);
        const data = await response.json();
        setFormData({
            nome: data.nome || '',
            descricao_curta: data.descricao_curta || '',
            descricao_completa: data.descricao_completa || '',
            status_atual: data.status_atual || '',
            vazao_atual_ls: data.vazao_atual_ls || 0,
            vazao_futura_ls: data.vazao_futura_ls || 0,
            populacao_atendida: data.populacao_atendida || 0
        });
        setLoading(false);
      } catch (error) {
        alert("Erro ao carregar dados.");
      }
    }
    fetchData();
  }, [id]);

  // 2. Função para lidar com a escrita nos inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
        ...prevState,
        [name]: value
    }));
  };

  // 3. Função para Salvar (PUT)
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
        const response = await fetch(`${API_BASE_URL}/empreendimentos/${id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        });

        if (response.ok) {
            alert("Salvo com sucesso!");
            navigate(`/empreendimento/${id}`); // Volta para a tela de detalhes
        } else {
            alert("Erro ao salvar.");
        }
    } catch (error) {
        console.error(error);
    }
  };

  if (loading) return <div className="p-10 text-center">Carregando formulário...</div>;

  return (
    <div className="min-h-screen bg-background p-6 font-sans flex justify-center">
      <div className="w-full max-w-2xl bg-card border border-border rounded-xl shadow-lg p-8">
        
        <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-sabesp-blue">Editar Empreendimento</h1>
            <button onClick={() => navigate(-1)} className="text-sm text-muted-foreground hover:text-foreground">Cancelar</button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
            
            {/* Nome */}
            <div>
                <label className="block text-sm font-medium mb-1">Nome do Empreendimento</label>
                <input type="text" name="nome" value={formData.nome} onChange={handleChange} 
                    className="w-full p-2 border border-input rounded bg-background" />
            </div>

            {/* Status */}
            <div>
                <label className="block text-sm font-medium mb-1">Status Atual</label>
                <select name="status_atual" value={formData.status_atual} onChange={handleChange} 
                    className="w-full p-2 border border-input rounded bg-background">
                    <option value="Operação">Operação</option>
                    <option value="Em Obras">Em Obras</option>
                    <option value="Planejamento">Planejamento</option>
                </select>
            </div>

            {/* Descrições */}
            <div className="grid grid-cols-1 gap-4">
                <div>
                    <label className="block text-sm font-medium mb-1">Descrição Curta (Subtítulo)</label>
                    <input type="text" name="descricao_curta" value={formData.descricao_curta} onChange={handleChange} 
                        className="w-full p-2 border border-input rounded bg-background" />
                </div>
                <div>
                    <label className="block text-sm font-medium mb-1">Descrição Completa</label>
                    <textarea name="descricao_completa" value={formData.descricao_completa} onChange={handleChange} rows={4}
                        className="w-full p-2 border border-input rounded bg-background" />
                </div>
            </div>

            {/* Métricas */}
            <div className="grid grid-cols-3 gap-4">
                <div>
                    <label className="block text-sm font-medium mb-1">Vazão Atual (L/s)</label>
                    <input type="number" name="vazao_atual_ls" value={formData.vazao_atual_ls} onChange={handleChange} 
                        className="w-full p-2 border border-input rounded bg-background" />
                </div>
                <div>
                    <label className="block text-sm font-medium mb-1">Vazão Futura (L/s)</label>
                    <input type="number" name="vazao_futura_ls" value={formData.vazao_futura_ls} onChange={handleChange} 
                        className="w-full p-2 border border-input rounded bg-background" />
                </div>
                <div>
                    <label className="block text-sm font-medium mb-1">População</label>
                    <input type="number" name="populacao_atendida" value={formData.populacao_atendida} onChange={handleChange} 
                        className="w-full p-2 border border-input rounded bg-background" />
                </div>
            </div>

            {/* Botão Salvar */}
            <button type="submit" className="w-full py-3 bg-sabesp-blue text-white font-bold rounded-lg hover:bg-blue-800 transition-colors mt-6">
                Salvar Alterações
            </button>

        </form>
      </div>
    </div>
  );
}

export default Edicao;